/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Profile_Meta_TitleInputs */

const id_profile_meta_title = /** @type {(inputs: Profile_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} | egdata.app`)
};

const ms_profile_meta_title = /** @type {(inputs: Profile_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} | egdata.app`)
};

const da_profile_meta_title = /** @type {(inputs: Profile_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} | egdata.app`)
};

const de_profile_meta_title = /** @type {(inputs: Profile_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} | egdata.app`)
};

const en_us2_profile_meta_title = /** @type {(inputs: Profile_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} | egdata.app`)
};

const es_es2_profile_meta_title = /** @type {(inputs: Profile_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} | egdata.app`)
};

const es_mx2_profile_meta_title = /** @type {(inputs: Profile_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} | egdata.app`)
};

const fil_profile_meta_title = /** @type {(inputs: Profile_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} | egdata.app`)
};

const fr_profile_meta_title = /** @type {(inputs: Profile_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} | egdata.app`)
};

const it_profile_meta_title = /** @type {(inputs: Profile_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} | egdata.app`)
};

const hu_profile_meta_title = /** @type {(inputs: Profile_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} | egdata.app`)
};

const nl_profile_meta_title = /** @type {(inputs: Profile_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} | egdata.app`)
};

const no_profile_meta_title = /** @type {(inputs: Profile_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} | egdata.app`)
};

const pl_profile_meta_title = /** @type {(inputs: Profile_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} | egdata.app`)
};

const pt_br2_profile_meta_title = /** @type {(inputs: Profile_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} | egdata.app`)
};

const pt_profile_meta_title = /** @type {(inputs: Profile_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} | egdata.app`)
};

const ro_profile_meta_title = /** @type {(inputs: Profile_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} | egdata.app`)
};

const fi_profile_meta_title = /** @type {(inputs: Profile_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} | egdata.app`)
};

const sv_profile_meta_title = /** @type {(inputs: Profile_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} | egdata.app`)
};

const vi_profile_meta_title = /** @type {(inputs: Profile_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} | egdata.app`)
};

const tr_profile_meta_title = /** @type {(inputs: Profile_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} | egdata.app`)
};

const cs_profile_meta_title = /** @type {(inputs: Profile_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} | egdata.app`)
};

const bg_profile_meta_title = /** @type {(inputs: Profile_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} | egdata.app`)
};

const ru_profile_meta_title = /** @type {(inputs: Profile_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} | egdata.app`)
};

const uk_profile_meta_title = /** @type {(inputs: Profile_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} | egdata.app`)
};

const ar_profile_meta_title = /** @type {(inputs: Profile_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} | egdata.app`)
};

const hi_profile_meta_title = /** @type {(inputs: Profile_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} | egdata.app`)
};

const th_profile_meta_title = /** @type {(inputs: Profile_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} | egdata.app`)
};

const ja_profile_meta_title = /** @type {(inputs: Profile_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} | egdata.app`)
};

const zh_cn2_profile_meta_title = /** @type {(inputs: Profile_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} | egdata.app`)
};

const zh_hant1_profile_meta_title = /** @type {(inputs: Profile_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} | egdata.app`)
};

const ko_profile_meta_title = /** @type {(inputs: Profile_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} | egdata.app`)
};

/**
* | output |
* | --- |
* | "{name} \| egdata.app" |
*
* @param {Profile_Meta_TitleInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const profile_meta_title = /** @type {((inputs: Profile_Meta_TitleInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Meta_TitleInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_profile_meta_title(inputs)
	if (locale === "ms") return ms_profile_meta_title(inputs)
	if (locale === "da") return da_profile_meta_title(inputs)
	if (locale === "de") return de_profile_meta_title(inputs)
	if (locale === "en-US") return en_us2_profile_meta_title(inputs)
	if (locale === "es-ES") return es_es2_profile_meta_title(inputs)
	if (locale === "es-MX") return es_mx2_profile_meta_title(inputs)
	if (locale === "fil") return fil_profile_meta_title(inputs)
	if (locale === "fr") return fr_profile_meta_title(inputs)
	if (locale === "it") return it_profile_meta_title(inputs)
	if (locale === "hu") return hu_profile_meta_title(inputs)
	if (locale === "nl") return nl_profile_meta_title(inputs)
	if (locale === "no") return no_profile_meta_title(inputs)
	if (locale === "pl") return pl_profile_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_profile_meta_title(inputs)
	if (locale === "pt") return pt_profile_meta_title(inputs)
	if (locale === "ro") return ro_profile_meta_title(inputs)
	if (locale === "fi") return fi_profile_meta_title(inputs)
	if (locale === "sv") return sv_profile_meta_title(inputs)
	if (locale === "vi") return vi_profile_meta_title(inputs)
	if (locale === "tr") return tr_profile_meta_title(inputs)
	if (locale === "cs") return cs_profile_meta_title(inputs)
	if (locale === "bg") return bg_profile_meta_title(inputs)
	if (locale === "ru") return ru_profile_meta_title(inputs)
	if (locale === "uk") return uk_profile_meta_title(inputs)
	if (locale === "ar") return ar_profile_meta_title(inputs)
	if (locale === "hi") return hi_profile_meta_title(inputs)
	if (locale === "th") return th_profile_meta_title(inputs)
	if (locale === "ja") return ja_profile_meta_title(inputs)
	if (locale === "zh-CN") return zh_cn2_profile_meta_title(inputs)
	if (locale === "zh-Hant") return zh_hant1_profile_meta_title(inputs)
	return ko_profile_meta_title(inputs)
});
export { profile_meta_title as "profile.meta.title" }